import * as v from "valibot";
import {vxNullableInput} from "@root/server/client/esweb/src/lib/valibot/vx.ts";

export const flow_email_form_name = "pwm--email_link_login_form";

export const EmailLinkLoginSchema = v.object({
    email: v.pipe(
        vxNullableInput(),
        v.string(),
        v.trim(),
        v.email("Zadejte platný e-mail"),
    ),
    remember_me: v.optional(v.boolean(), false)
});

export type EmailLinkLoginFormValues = v.InferInput<typeof EmailLinkLoginSchema>;

export interface EmailLinkLoginFormProps {
    submitUrl?: string;
    initialEmail?: string;
}
